/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Xml_Feed_SubtitleInputs */

const cs_xml_feed_subtitle = /** @type {(inputs: Xml_Feed_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeden feed jen pro čtení s vašimi aktivními, povolenými inzeráty — pro portály a partnery, kteří umí načíst XML ve formátu Sreality přímo.`)
};

const en_xml_feed_subtitle = /** @type {(inputs: Xml_Feed_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A single read-only XML feed of your active, enabled listings — for portals and partners that ingest Sreality-dialect XML directly.`)
};

/**
* | output |
* | --- |
* | "A single read-only XML feed of your active, enabled listings — for portals and partners that ingest Sreality-dialect XML directly." |
*
* @param {Xml_Feed_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const xml_feed_subtitle = /** @type {((inputs?: Xml_Feed_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xml_Feed_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_xml_feed_subtitle(inputs)
	return cs_xml_feed_subtitle(inputs)
});